<div class="edit-top">
	<div class="edit-control-wrap">
		<div *ngIf="selectedRecord&&selectedRecord[this.isEditedCol]" class="edit-control" [ngClass]="{'first-record': editRecordList.indexOf(selectedRecord)===0, 'last-record':editRecordList.indexOf(selectedRecord)===editRecordList.length-1}">
			<div class="go-prev">
				<i class="glyphicons glyphicons-chevron-left" (click)="goPrevRecord()"></i>
			</div>
			<div class="card-index">
				{{editRecordList.indexOf(selectedRecord) + 1}} / {{editRecordList.length}}
			</div>
			<div class="go-next">
				<i class="glyphicons glyphicons-chevron-right" (click)="goNextRecord()"></i>
			</div>
		</div>
		<div *ngIf="!selectedRecord||!selectedRecord[this.isEditedCol]" class="edit-control first-record" [ngClass]="{'last-record': !this.editRecordList.length}">
			<div class="go-prev">
				<i class="glyphicons glyphicons-chevron-left" (click)="goPrevRecord()"></i>
			</div>
			<div class="card-index">
				0 {{editRecordList.length ? ' / ' + editRecordList.length : ''}}
			</div>
			<div class="go-next">
				<i class="glyphicons glyphicons-chevron-right" (click)="goNextRecord()"></i>
			</div>
		</div>
	</div>
</div>
<div *ngIf="selectedRecord" class="edit-content">
	<ng-container *ngFor="let col of columns;let idx = index;">
		<div *ngIf="col.isDisplay!==false && !col.info.hideFromEditing" class="edit-row">
			<div class="edit-column" appHtmlTooltip [tooltip]="col.info.tooltip">{{col.name}}</div>
			<div class="edit-value" title="{{selectedRecord[col.prop]}}" [ngClass]="{'field-dirty': checkFieldDirty(col)}">
				<app-feat-edit-cell
					[(cellValue)]="selectedRecord[col.prop]"
					[column]="{prop: col.prop, info: col.info, isUppercase: col.info.isUppercase}"
					[domainsByColumn]="domainsByColumn"
					[standardColName]="col.info.standardColName"
					[isEditDisabled]="col.info.isEditDisabled || disableEditing"
					[cssClass]="{
						'invalid-select': domainsByColumn[col.prop] && domainsByColumn[col.prop].type==='list' && selectedRecord[col.prop] && domainsByColumn[col.prop].list?.indexOf(selectedRecord[col.prop]) < 0
					}"
					(valueChange)="onChange(col)"
				></app-feat-edit-cell>
				<!-- <input *ngIf="!domainsByColumn[col.prop] || domainsByColumn[col.prop].type !== 'list'"
					name="{{col.prop}}-{{idx}}"
					[disabled]="col.info.isEditDisabled || disableEditing"
					pattern="{{domainsByColumn[col.prop] ? domainsByColumn[col.prop].pattern : ''}}"
					appValidateRange="{{domainsByColumn[col.prop] ? domainsByColumn[col.prop].range : null}}"
					[(ngModel)]="selectedRecord[col.prop]"
					(ngModelChange)="onChange(col)"
				>
				<select *ngIf="domainsByColumn[col.prop] && domainsByColumn[col.prop].type==='list'" name="{{col.prop}}-{{idx}}"
					[disabled]="col.info.isEditDisabled || disableEditing"
					[ngClass]="{
							'invalid-select': selectedRecord[col.prop] && domainsByColumn[col.prop].list?.indexOf(selectedRecord[col.prop]) < 0
						}"
					[(ngModel)]="selectedRecord[col.prop]" (ngModelChange)="onChange(col)">
					<ng-container *ngIf="selectedRecord[col.prop] && domainsByColumn[col.prop].list?.indexOf(selectedRecord[col.prop]) < 0">
						<option disabled>{{selectedRecord[col.prop]}}</option>
					</ng-container>
					<option *ngFor="let val of domainsByColumn[col.prop].list" [ngValue]="val">{{val}}</option>
					<option [ngValue]="null">Null</option>
				</select> -->
			</div>
		</div>
	</ng-container>
</div>